import { render, staticRenderFns } from "./radioSelect.vue?vue&type=template&id=38966a62&scoped=true&name=radioSelect&"
import script from "./radioSelect.vue?vue&type=script&lang=js&"
export * from "./radioSelect.vue?vue&type=script&lang=js&"
import style0 from "./radioSelect.vue?vue&type=style&index=0&id=38966a62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38966a62",
  null
  
)

export default component.exports